import { useQuery } from "@tanstack/react-query";
import { fetchClosureReasons } from "../../lib/everifyStatusApi";

export const useClosureReasons = (caseNumber, enabled = true) =>
  useQuery({
    queryKey: ["closure-reasons", caseNumber],
    queryFn: () => fetchClosureReasons(caseNumber),
    enabled: Boolean(caseNumber) && enabled,
    staleTime: 1000 * 60 * 10,
  });
